module.exports = __webpack_public_path__ + "img/samsung.b2b1b939.png";